"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var classnames_1 = __importDefault(require("classnames"));
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useOnScreen_1 = __importDefault(require("./useOnScreen"));
var SearchInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, onClear = _a.onClear, onFocus = _a.onFocus, _b = _a.placeholder, placeholder = _b === void 0 ? 'searchBar.placeholder' : _b;
    var t = (0, next_intl_1.useTranslations)();
    var searchInputRef = (0, react_1.useRef)(null);
    var openSearch = (0, apps_shared_1.useOpenGameSearch)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var isOnScreen = (0, useOnScreen_1.default)(searchInputRef);
    var onSearchAreaClick = (0, react_1.useCallback)(function (e) {
        var _a;
        if (Object.keys(breakpoints).length > 0 && breakpoints.mobile) {
            e.stopPropagation();
            e.preventDefault();
            openSearch();
            return false;
        }
        else {
            (_a = searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            onFocus();
        }
    }, [breakpoints, onFocus, openSearch]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.searchInputContainer, 'searchInput') },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.searchInputWrapper, onClick: onSearchAreaClick },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.mobileDisabled, onClick: onSearchAreaClick }),
                react_1.default.createElement("img", { className: styles_module_scss_1.default.search, src: "/img/icons/search.svg", alt: "search" }),
                react_1.default.createElement("input", { className: styles_module_scss_1.default.searchInput, ref: searchInputRef, value: value, onChange: onChange, placeholder: Object.keys(breakpoints).length > 0 && breakpoints.mobile
                        ? t('translation.mainBannerInfoGames')
                        : t(placeholder) }),
                value && (react_1.default.createElement("img", { onClick: onClear, className: styles_module_scss_1.default.trash, src: "/img/icons/trash.svg", alt: "search" })),
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient" }, t('translation.search')))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.searchInputPosition, 'searchInput', !isOnScreen && styles_module_scss_1.default.searchInputPositionView) },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.searchInputWrapper, onClick: onSearchAreaClick },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.mobileDisabled, onClick: onSearchAreaClick }),
                react_1.default.createElement("img", { className: styles_module_scss_1.default.search, src: "/img/icons/search.svg", alt: "search" }),
                react_1.default.createElement("input", { className: styles_module_scss_1.default.searchInput, placeholder: t('translation.mainBannerInfoGames') }),
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient" }, t('translation.search'))))));
};
exports.default = SearchInput;
